var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.currentRouteName != 'Home')?_c('the-header'):_vm._e(),_c('router-view'),(_vm.currentRouteName != 'Home' && _vm.currentRouteName != 'details/Item')?_c('the-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }